import type { Question } from '../../types';
import { getTagData } from '../../utils';
import { QuestionDetails } from '../question-details';

interface SingleQuestionDetailsProps {
  question: Question;
}

export default function SingleQuestionDetails(props: Readonly<SingleQuestionDetailsProps>) {
  const { question } = props;
  const { questionGroup, tags } = question;
  const { difficulty, calculation, los } = getTagData(tags);

  return (
    <QuestionDetails
      refCode={question.refCode}
      difficulty={difficulty}
      calculation={calculation}
      type={questionGroup?.type}
      details={question.details ?? ''}
      choices={question.metadata?.choices}
      solution={question.solution?.value ?? undefined}
      reference={question.metadata.reference ?? undefined}
      correctAnswer={question.correctAnswer?.value}
      los={los}
    />
  );
}
